import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Modal from 'src/Components/shared/Modal'
import { If, Text } from 'src/Components'
import Markdown from 'markdown-to-jsx'

const disclaimerPropTypes = {
  corpDisclaimer: PropTypes.string,
  custDisclaimer: PropTypes.string,
  equalHousingType: PropTypes.string,
  toggle: PropTypes.func
}

const markdownPropTypes = {
  children: PropTypes.any,
  qa: PropTypes.string
}

const MarkDownDiv = ({ children, qa }) => (
  <Text align='left' element='div' data-qa={qa}>
    <Markdown>{children}</Markdown>
  </Text>
)

const DisclaimerModal = ({
  equalHousingType,
  corpDisclaimer,
  custDisclaimer,
  toggle
}) => (
  <Modal
    type='quiet'
    title={
      <FormattedMessage
        id='DisclaimerModal.title'
        defaultMessage='Important Disclaimers'
      />
    }
    openKey='layout.showDisclaimer'
    toggle={toggle}
  >
    <If condition={custDisclaimer}>
      <MarkDownDiv qa='customerDisclaimer'>{custDisclaimer}</MarkDownDiv>
      <br />
    </If>
    <Text align='left' data-qa='aprDisclaimer'>
      <FormattedMessage
        id='DisclaimerModal.body'
        defaultMessage='APR is based on a reasonably current index and margin from the Freddie Mac PMMS. This message is for information purposes only and is not an advertisement to extend customer credit as defined by Section 12 CFR 1026.2 Regulation Z. Program rates, terms, and conditions are subject to change at any time. All examples of potential mortgage products above are estimates for illustration purposes only. All programs and mortgage products are subject to borrower income, credit, and property approval. Not all borrowers will qualify. This is not an offer for extension of credit or a commitment to lend. Home valuations are estimates purchased from a third-party data provider. Actual appraised value at the time of a transaction may vary.'
      />{' '}
      <If condition={equalHousingType === 'lender'}>Equal Housing Lender.</If>
      <If condition={equalHousingType === 'opportunity'}>
        Equal Housing Opportunity.
      </If>
      <If condition={equalHousingType === 'equal_opportunity_lender'}>
        Equal Opportunity Lender.
      </If>
    </Text>
    <If condition={corpDisclaimer}>
      <br />
      <MarkDownDiv qa='companyDisclaimer'>{corpDisclaimer}</MarkDownDiv>
    </If>
  </Modal>
)

MarkDownDiv.propTypes = markdownPropTypes
DisclaimerModal.propTypes = disclaimerPropTypes

export default DisclaimerModal
